<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    style="height: 494px;"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-base text-blueGray-700">
            오늘의 크롤링 현황
          </h3>
          <p class="text-sm text-blueGray-400 mt-1">
            {{ formattedDate }}
          </p>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto flex flex-col justify-between">
      <!-- Stats Grid -->
      <div class="grid grid-cols-2 gap-4">
        <div class="border-l-4 border-red-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">언론</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.press_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-red-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.press_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
        <div class="border-l-4 border-violet-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">블로그</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.blog_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-violet-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.blog_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
        <div class="border-l-4 border-yellow-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">지식인</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.kin_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-yellow-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.kin_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
        <div class="border-l-4 border-teal-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">카페</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.cafe_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-teal-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.cafe_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
        <div class="border-l-4 border-purple-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">커뮤니티</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.community_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-purple-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.community_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
        <div class="border-l-4 border-orange-500 pl-4 py-2">
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs text-blueGray-400 uppercase font-semibold">유튜브</p>
            <p class="text-lg font-bold text-blueGray-700">
              <animated-number :value="todayData.youtube_count || 0" />
              <span class="text-xs font-normal text-blueGray-400 ml-1">건</span>
            </p>
          </div>
          <div class="w-full bg-blueGray-200 rounded-full h-3">
            <div
              class="bg-orange-500 h-3 rounded-full transition-all ease-out"
              :style="{ width: getPercentage(todayData.youtube_count), transitionDuration: '1200ms' }"
            ></div>
          </div>
        </div>
      </div>

      <!-- Total -->
      <div class="mt-4 pt-4 border-t border-blueGray-200">
        <div class="flex items-center justify-between">
          <p class="text-sm text-blueGray-600 font-semibold">오늘 총 수집량</p>
          <p class="text-3xl font-bold text-emerald-500">
            <animated-number :value="totalToday" />
            <span class="text-base font-normal text-blueGray-400 ml-1">건</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from '@/components/common/AnimatedNumber.vue';

export default {
  name: 'card-today-stats',
  components: {
    AnimatedNumber
  },
  props: {
    todayData: {
      type: Object,
      default: () => ({
        press_count: 0,
        blog_count: 0,
        kin_count: 0,
        cafe_count: 0,
        community_count: 0,
        youtube_count: 0,
        collection_date: null
      })
    }
  },
  data() {
    return {
      isAnimated: false
    };
  },
  computed: {
    totalToday() {
      return (
        (this.todayData.press_count || 0) +
        (this.todayData.blog_count || 0) +
        (this.todayData.kin_count || 0) +
        (this.todayData.cafe_count || 0) +
        (this.todayData.community_count || 0) +
        (this.todayData.youtube_count || 0)
      );
    },
    formattedDate() {
      if (this.todayData.collection_date) {
        const date = new Date(this.todayData.collection_date);
        return date.toLocaleDateString('ko-KR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }
      return new Date().toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    maxCount() {
      // For visual comparison - max value among all channels
      const counts = [
        this.todayData.press_count || 0,
        this.todayData.blog_count || 0,
        this.todayData.kin_count || 0,
        this.todayData.cafe_count || 0,
        this.todayData.community_count || 0,
        this.todayData.youtube_count || 0
      ];
      return Math.max(...counts, 1);
    }
  },
  watch: {
    todayData: {
      handler() {
        this.triggerAnimation();
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.isAnimated = true;
      }, 100);
    });
  },
  methods: {
    getPercentage(count) {
      const value = count || 0;
      if (this.totalToday === 0) return '0%';
      if (!this.isAnimated) return '0%';
      // Calculate percentage based on total, not max value
      const percentage = (value / this.totalToday) * 100;
      // Minimum 1% for visibility if there's any data
      return `${Math.max(percentage, value > 0 ? 1 : 0)}%`;
    },
    triggerAnimation() {
      this.isAnimated = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.isAnimated = true;
        }, 50);
      });
    }
  }
};
</script>
